import { render, staticRenderFns } from "./DeviceAvailabilityCard.vue?vue&type=template&id=72b1e0fe&scoped=true&"
import script from "./DeviceAvailabilityCard.vue?vue&type=script&lang=js&"
export * from "./DeviceAvailabilityCard.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAvailabilityCard.vue?vue&type=style&index=0&id=72b1e0fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1e0fe",
  null
  
)

export default component.exports